import { cleanComponentNameToValues } from "./cleanComponentNameToValues";
import { extractLiquidMessageComponentNames } from "./extractLiquidMessageComponentNames";
import { resolveComponentName } from "./resolveComponentName";
import type { ComponentStoreData } from "./types";

/**
 * Appends active Content Optimization component variant texts from the component store to base
 * liquid scan fields when the message references {% message_component %} tags.
 */
export const addComponentStoreToLiquidScanFields = (
  baseLiquidFields: string[],
  isContentOptimization: boolean,
  componentStoreData: Partial<ComponentStoreData> | null
): string[] => {
  if (!isContentOptimization) {
    return baseLiquidFields;
  }

  const referencedComponentNames = extractLiquidMessageComponentNames(...baseLiquidFields);
  const componentNameToValues = cleanComponentNameToValues(componentStoreData);
  const variantTexts = [...referencedComponentNames].flatMap((name) => {
    const canonicalName = resolveComponentName(name, componentNameToValues.keys());
    if (!canonicalName) {
      return [];
    }
    return componentNameToValues.get(canonicalName) ?? [];
  });

  return [...baseLiquidFields, ...variantTexts];
};
